$(document).on('click', '.buy-buttons button', function () {
    console.log("Welcome to Meal prep Ottawa");

    function addCartAttribute(retryCount = 3) {
        // Retrieve the FCM token
        const fcmToken = window?.identity?.fcmToken || null;
        
        if (fcmToken) {
            console.log('Adding FCM token to cart attributes:', fcmToken);

            // Clear the existing attribute if present, then re-add
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    attributes: {
                        fcm_token: null  // Clear existing token first
                    }
                })
            })
            .then(() => new Promise(resolve => setTimeout(resolve, 500))) // Delay to ensure Shopify updates the cart
            .then(() => {
                // Re-add the FCM token immediately after clearing
                return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        attributes: {
                            fcm_token: fcmToken
                        }
                    })
                });
            })
            .then(response => response.json())
            .then(data => {
                console.log('Cart attribute updated with FCM token:', data);
            })
            .catch(error => {
                console.error('Error updating cart attribute:', error);
            });
        } else if (retryCount > 0) {
            console.warn('FCM token not available, retrying...');
            setTimeout(() => addCartAttribute(retryCount - 1), 500); // Retry after 500ms
        } else {
            console.warn('FCM token is not available after retries');
        }
    }

    // Call the function to add or update the cart attribute with FCM token
    addCartAttribute();
});


/*
$(document).on("click", 'button[name="checkout"]', function () {
  const fcmSecret = window?.identity?.fcmToken || null;
  $.getJSON('/cart.js', function(cartData) {
    console.log("Cart Data:", cartData);
  
    const cartAttributes = cartData.attributes;
    console.log("Cart Attributes:", cartAttributes);

    if (cartAttributes && cartAttributes.fcm_token) {
      alert(`FCM Token in cart: ${cartAttributes.fcm_token}\nFCM Token in window.identity: ${fcmSecret}`);
    } else {
      alert("No FCM Token attribute found.");
    }
  })
  .fail(function() {
    console.error("Failed to retrieve cart data.");
  });
});
*/
